import useToast from '@/hooks/useToast';
import { useMediaQuery } from '@mui/material';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useContext, useEffect, useRef, useState } from 'react';
import { useQueryClient } from 'react-query';
import { putFolderCover } from '../../../apis/tms/folder.api';
import { handleSubmitForm } from '../../../common/formCallApi';
import { FOLDER_INFO, GROUP_ROLE_ACCESS } from '../../../constant/QueryKeyName';
import { imgAcceptTypeUpload } from '../../../constant/fileType';
import { DEFAULT_GROUP_COVER } from '../../../constant/imgImport';
import { ROLE_ACCESS } from '../../../constant/storage';
import AuthContext from '../../../state/auth/AuthContext';
import { CoverWrapper } from '../../image/Cover';
import ChangeCoverImageModal from '../../modal/training-module/ChangeCoverImageModal';
import GroupAvatar from './GroupAvatar';

const GroupCover: React.FunctionComponent = () => {
  const { setLoading } = useContext(AuthContext);
  const toast = useToast();
  const matches = useMediaQuery('(min-width:1024px)');
  const router = useRouter();
  const queryClient = useQueryClient();
  const [changingCover, setChangingCover] = useState<boolean>(false);
  const [folderId, setFolderId] = useState<string>('');

  const uploadCoverRef = useRef<HTMLInputElement>(null);

  const [selectedCover, setSelectedCover] = useState<any>(undefined);
  const [previewCover, setPreviewCover] = useState<string | undefined>(
    undefined
  );
  const [openChangeCover, setOpenChangeCover] = useState<boolean>(false);

  const folder: any = queryClient.getQueryData([FOLDER_INFO, folderId]);

  const mineRole = queryClient.getQueryData([GROUP_ROLE_ACCESS, folderId]);

  const handleChangeCover = () => {
    handleSubmitForm({
      callback: () => {},
      data: {
        Id: folderId,
        Cover: selectedCover,
      },
      id: folderId || '',
      asyncFunc: putFolderCover,
      formCancelCallBack: () => {},
      toggleSuccessModalNoti: () => {
        queryClient.refetchQueries([FOLDER_INFO, folderId]);
        setChangingCover(false);
        toast('Cập nhật thông tin thành công', 'success');
      },
      toggleErrorModalNoti: () =>
        toast('Có lỗi xảy ra, vui lòng thử lại.', 'error'),
      setLoading,
    });
  };

  const onSelectCover = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedCover(undefined);
      toast('Có lỗi xảy ra, vui lòng thử lại.', 'error');
      return;
    }
    const file = e.target.files?.item(0);
    if (!file) {
      toast('Có lỗi xảy ra, vui lòng thử lại.', 'error');
      return;
    }
    setSelectedCover(file);
    setChangingCover(true);
  };
  useEffect(() => {
    if (router.isReady) {
      setFolderId(router.query?.gid as string);
    }
  }, [router]);

  useEffect(() => {
    if (!selectedCover) {
      setPreviewCover(undefined);
      return;
    }

    const objectUrl = URL.createObjectURL(selectedCover);
    setPreviewCover(objectUrl);

    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedCover]);
  const coverOptions = !changingCover ? (
    <div
      className="cursor-pointer absolute bottom-4 right-4 rounded-md bg-[#11111166] py-2 px-3 h-fit w-fit text-white flex gap-x-1"
      onClick={() => {
        setOpenChangeCover(true);
      }}
    >
      <Image
        src="/icons/pencil-line-icon.svg"
        alt="edit-icon"
        height={20}
        width={20}
      />
      {matches && `Ảnh bìa`}
    </div>
  ) : (
    <div className="absolute bottom-4 right-4 flex gap-x-1 text-xs">
      <div
        className="cursor-pointer  rounded-md bg-transparent py-1.5 px-[10px] h-fit w-fit text-white border-[1px] border-solid border-white flex gap-x-1"
        onClick={() => {
          setChangingCover(false);
          setSelectedCover(undefined);
          setPreviewCover(undefined);
        }}
      >
        Hủy
      </div>
      <div
        className="cursor-pointer rounded-md bg-[#242424] py-1.5 px-[10px] h-fit w-fit text-white flex gap-x-1 bg-origin-border border-[1px] border-solid border-[#242424]"
        onClick={handleChangeCover}
      >
        Lưu thay đổi
      </div>
    </div>
  );

  return (
    <>
      <input
        ref={uploadCoverRef}
        type="file"
        className="hidden"
        onChange={onSelectCover}
        accept={imgAcceptTypeUpload.join(', ')}
      />
      <div className="relative pb-10 mb-8 -mx-3 md:mx-0">
        <CoverWrapper
          src={previewCover || folder?.cover || DEFAULT_GROUP_COVER}
        >
          {mineRole === ROLE_ACCESS.Owner && coverOptions}
        </CoverWrapper>
        <GroupAvatar />
      </div>
      <ChangeCoverImageModal
        open={openChangeCover}
        onClose={() => setOpenChangeCover(false)}
        confirmCallback={() => uploadCoverRef?.current?.click()}
      />
    </>
  );
};

export default GroupCover;
